// frontend/src/components/cart/WeightDisplay.js - Updated version

import React from 'react';

// Helper function to format weight display
export const formatWeightDisplay = (item) => {
    if (item.priceType === 'perKg') {
        return `${item.quantity} kg`;
    } else if (item.priceType === 'perDozen') {
        return `${item.quantity} dozen`;
    } else if (item.priceType === 'perPack') {
        return `${item.quantity} pack${item.quantity > 1 ? 's' : ''}`;
    } else if (item.selectedWeight) {
        return `${item.quantity} × ${item.selectedWeight}`;
    }
   
    return `${item.quantity} units`;
};

// Reusable component for displaying weight/quantity
const WeightDisplay = ({ item }) => {
    const weightStr = formatWeightDisplay(item);
   
    return (
        <span className="text-gray-600 text-sm">
            Quantity: {weightStr}
        </span>
    );
};

// Component for cart item weight display
const CartItemWeight = ({ item }) => {
    return (
        <div className="flex items-center space-x-2">
            <WeightDisplay item={item} />
            {item.priceType === 'fixed' && item.selectedWeight && (
                <span className="text-gray-500 text-xs">
                    (Selected Weight: {item.selectedWeight})
                </span>
            )}
            {item.priceType === 'perDozen' && (
                <span className="text-gray-500 text-xs">
                    (Per Dozen)
                </span>
            )}
            {item.priceType === 'perPack' && (
                <span className="text-gray-500 text-xs">
                    (Per Pack)
                </span>
            )}
        </div>
    );
};

// Component for order details weight display
const OrderItemWeight = ({ item }) => {
    return (
        <div className="text-sm text-gray-600">
            <WeightDisplay item={item} />
            {item.priceType === 'fixed' && item.selectedWeight && (
                <span className="block text-gray-500">
                    Weight Option: {item.selectedWeight}
                </span>
            )}
            {item.priceType === 'perDozen' && (
                <span className="block text-gray-500">
                    Price Type: Per Dozen
                </span>
            )}
            {item.priceType === 'perPack' && (
                <span className="block text-gray-500">
                    Price Type: Per Pack
                </span>
            )}
        </div>
    );
};

export { WeightDisplay, CartItemWeight, OrderItemWeight };